/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreEyeShow = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M11.448 8A3.449 3.449 0 1 1 4.55 8a3.449 3.449 0 0 1 6.898 0zm4.333-.796c-2.108-2.742-4.635-4.131-7.511-4.131h-.541c-2.932 0-5.46 1.352-7.511 4.019-.29.394-.29 1.009 0 1.401.121.157.257.322.391.486v.007h.005c1.482 1.82 3.744 3.942 7.115 3.942h.541c3.744 0 6.079-2.477 7.511-4.339a1.201 1.201 0 0 0 0-1.385z"
    />
    <path
      fill="currentColor"
      d="M9.724 8c0-.951-.774-1.725-1.725-1.725S6.275 7.049 6.275 8c0 .951.773 1.725 1.724 1.725S9.724 8.951 9.724 8z"
    />
  </svg>
);

IconCoreEyeShow.displayName = 'IconCoreEyeShow';

IconCoreEyeShow.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreEyeShow);
IconCoreEyeShow.displayName = 'IconCoreEyeShow';
